exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-dialog-container {\n  max-width: none !important;\n}\n.map-button {\n  width: 35px;\n  height: 35px;\n  text-align: center;\n}\n.app-icon-button {\n  height: 24px !important;\n}\nh1 {\n  font-size: 26px;\n}\nh2 {\n  font-size: 20px !important;\n  font-weight: 100;\n}\nh3 {\n  font-size: 20px !important;\n  font-weight: 400 !important;\n}\n.author {\n  font-size: 10px;\n  padding-left: 20px;\n}\n.author a img,\n.author a span {\n  display: block;\n  float: left;\n}\n.author img {\n  margin-right: 3px;\n  width: 20px;\n  height: 20px;\n}\n@media (max-width: 600px) {\n  .author {\n    display: none;\n  }\n}\n#map {\n  width: 100vw;\n  position: absolute;\n  top: 64px;\n  bottom: 0;\n  cursor: auto !important;\n}\n@media (max-width: 960px) {\n  #map {\n    top: 48px;\n  }\n}\n@media (max-width: 600px) {\n  #map {\n    top: 50px;\n  }\n}\n:host /deep/ .description img {\n  width: 200px !important;\n  clear: both !important;\n  display: block !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/map/map.component.less
// module id = 387
// module chunks = 1